import { render, staticRenderFns } from "./UnitInput.vue?vue&type=template&id=ffc190aa&"
import script from "./UnitInput.vue?vue&type=script&lang=ts&"
export * from "./UnitInput.vue?vue&type=script&lang=ts&"
import style0 from "./UnitInput.vue?vue&type=style&index=0&id=ffc190aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports